<template>
  <button
    @click="$emit('click')"
    class="hamburger"
    :class="`hamburger--${ type }`"
  >
    <span class="hamburger__title">{{ title }}</span>
    <span class="hamburger__wrapper">
      <div class="hamburger__bar"/>
      <div class="hamburger__bar"/>
      <div class="hamburger__bar"/>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'open',
      validator: propValue => ['open', 'close'].includes(propValue)
    }
  },
  computed: {
    title () {
      return this.type === 'open' ? 'Zamknij' : 'Menu'
    }
  }
}
</script>

<style lang="scss" scoped>
  .hamburger {
    @include reset-button;
    position: fixed;
    right: 20px;
    top: 40px;
    cursor: pointer;
    z-index: z(submit-map) + 1;
    transition: opacity $base-transition;

    &:hover {
      opacity: .75;
    }

    &__title {
      padding-right: 8px;
      text-transform: uppercase;
      letter-spacing: .05em;
      color: $accent-opposite-color;
    }

    &__title,
    &__wrapper {
      display: inline-block;
      vertical-align: middle;
    }

    @include media-up(md) {
      right: 30px;
    }

    @include media-up(xl) {
      right: 40px;
      top: 45px;
    }

    &__bar {
      background: $base-opposite-color;
      height: 4px;
      width: 26px;
      margin: 4px auto;

      transition: all $base-transition;
      transform-origin: center;
    }

    &--open &__bar {
      &:nth-child(1) {
        transform: translateY(8.5px) rotate(45deg);
      }
      &:nth-child(2) {
        opacity: 0;
      }
      &:nth-child(3) {
        transform: translateY(-8px) rotate(-45deg);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/ContestMenu/MenuButton.vue